import { supabase } from "@/lib/supabase";
import type { Language } from "@/lib/translations";

export type MenuDishCourses = {
  primeros: string[];
  segundos: string[];
  postres: string[];
};

function asStringList(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  return value.map((v) => (typeof v === "string" ? v.trim() : "")).filter(Boolean);
}

/** Resolve dish courses in the viewer's language for web menu detail / shared links. */
export async function fetchMenuDishTranslations(
  menuId: string,
  targetLanguage: Language
): Promise<MenuDishCourses | null> {
  if (!menuId) return null;
  try {
    const { data, error } = await supabase.functions.invoke("translate-menu-dishes", {
      body: {
        action: "get",
        menu_id: menuId,
        target_language: targetLanguage,
      },
    });
    if (error || !data?.courses) return null;
    return {
      primeros: asStringList(data.courses.primeros),
      segundos: asStringList(data.courses.segundos),
      postres: asStringList(data.courses.postres),
    };
  } catch {
    return null;
  }
}
